import { AiMarkdown } from '@/platform/components/ai-markdown';

/** Intranet questions and KI agents share the platform markdown answer. */
export function IntranetAiAnswer({ text, className }: { text: string; className?: string }) {
  return <AiMarkdown text={text} className={className} />;
}
